import Button from '@insided/control/uikit/Button'

interface Props {
  isLoading: boolean
  onSaveChanges: () => void
  onCancel: () => void
}

const TeamNotesButtons = ({ isLoading, onSaveChanges, onCancel }: Props) =>
  <div className='team-notes__buttons'>
    <Button
      variant='success'
      title='Save changes'
      isLoading={isLoading}
      onClick={onSaveChanges}
      className='qa-save-notes'
    />
    <Button
      title='Cancel'
      onClick={onCancel}
    />
  </div>

export default TeamNotesButtons
